<template>
  <div class="variant_attrs_box">
    <div
      class="variant_select variant-select"
      v-for="(item, index) in palette_attrs"
      :class="{
        special_attr_select: is_special_attr(item.special_native_name) && variants_show_config === 'dropdown',
      }"
      :style="{
        'margin-bottom': theme == 'default' ? '20px' : '',
      }"
      :key="item.name"
    >
      <label
        v-if="type == 'detail' && variants_show_config != 'dropdown'"
        class="secondary_title variant-select__title"
        >{{ item.name }}：
        {{ !smartShowAttrsName || verify_config(index, variant_attrs[index].value) ? variant_attrs[index].value : '' }}
      </label>
      <div v-if="variants_show_config == 'dropdown'">
        <v-iselect
          :theme="theme"
          :type="type"
          :index="index"
          :value="variant_attrs[index].value"
          :item="item"
          :palette_config="palette_config"
        ></v-iselect>
      </div>
      <v-customSwiper
        v-else
        :not_swiper="isCloseSwiper(item)"
        :total_num="paletteAttrNumber(item)"
        :page_num="(elWidth - 25) / validLabelWidth"
        button_type="label_button"
      >
        <!-- 即使是设置成label形式 遇到特殊属性任然采用select -->
        <div class="labelStyleBox">
          <div v-if="isPopup && !item.palette_type" class="popupSelect">
            <v-selectStyle
              :attrs="item"
              :index="index"
              :variant_attrs="variant_attrs"
              :show_dropdown="true"
              :theme="theme"
            ></v-selectStyle>
          </div>
          <v-paletteLabel
            ref="labelStyleWrap"
            v-else
            :palette_config="palette_config"
            :mouse_enter="mouse_enter"
            :type="type"
            :palette_attr_item="item"
            :variant_attrs="variant_attrs"
            :theme="theme"
            :url="url"
            :has_special_attrs="has_special_attrs"
            :index="index"
            :style="use_model_name && theme !== 'default' ? 'justify-content: flex-start;' : 'justify-content: center;'"
            :model_name="setHashCode(Math.random().toString(36).slice(-6))"
            :verify_config="verify_config"
            :test_color="test_color"
            :isPopup="isPopup"
            @change="(value) => $emit('change', index, { name: item.name, value })"
          ></v-paletteLabel>
          <!-- <div v-else class="athena-special-select">
            <v-selectStyle
              :attrs="item"
              :index="index"
              :variant_attrs="variant_attrs"
              :show_dropdown="theme == 'athena'"
              :theme="theme"
            ></v-selectStyle>
          </div> -->
        </div>
      </v-customSwiper>
    </div>
    <div class="d-md-none d-block number-box">
      <v-numberLabel
        v-if="hide_number_select !== 1 && has_special_attrs"
        :product_res="product_res"
        :add_cart_data="add_cart_data"
        :disabled="disabled"
        :stock="stock"
        :theme="theme"
        :add_cart="add_cart"
      ></v-numberLabel>
    </div>
  </div>
</template>

<script>
import vIselect from './iselect'
import vIlabel from './ilabel'
import vPaletteLabel from './paletteLabel.vue'
import vSelectStyle from '../../../../views/venue/js/view/product/selectStyle.vue'
import vCustomSwiper from '../../common/customSwiper.vue'
import vNumberLabel from '../../../../views/venue/js/view/product/numberLabel.vue'
import paletteList from './paletteList.json'
export default {
  props: [
    'type',
    // "product_res",
    'variants_show_config',
    'variant_attrs',
    // "product_palette",
    'palette_attrs',
    'palette_config',
    'mouse_enter',
    'url',
    'theme',
    'has_special_attrs',
    'hide_number_select',
    'product_res',
    'add_cart_data',
    'disabled',
    'stock',
    'add_cart',
    'keys',
    'use_model_name',
    'isPopup', // 推荐商品调色板弹窗配置，色块与下拉框组合
    'smartShowAttrsName', //不传默认在属性名后跟上属性值,为true会根据属性值判断 属于色块和图片才显示属性值
  ],
  emits: ['change'],
  data() {
    return {
      validLabelNum: 0,
      elWidth: 200,
      validLabelWidth: 0,
      paletteListLowerCase: [],
    }
  },
  methods: {
    test_color(e) {
      return this.paletteListLowerCase.includes(e.toString().toLowerCase())
    },
    is_special_attr(name) {
      let { special_attr_key } = this.$store.state
      if (!name || !special_attr_key) return false
      else if (name.toLowerCase() == special_attr_key) return true
    },
    //根据使用的模块生成hashcode
    setHashCode(str) {
      return str.split('').reduce((prevHash, currVal) => ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0, 0)
    },
    isCloseSwiper(item) {
      if (this.isPopup && item.palette_type) {
        return false
      }
      return !!(this.type != 'card' || this.palette_config.show_num)
    },
    paletteAttrNumber(item) {
      if (this.isPopup && item?.value?.length) {
        return item.value.length
      }
      return this.type == 'detail' || !this.palette_config.show_num ? this.validLabelNum : this.palette_config.show_num
    },
    verify_config(index, value) {
      let onOff = false
      if (!this.palette_attrs || !this.palette_attrs[index]) return onOff
      let { config, palette_type } = this.palette_attrs[index]
      if (!config || !Object.keys(config).length || !palette_type) return onOff
      switch (palette_type) {
        case 'manual':
          // 调色板为手动配置的时候 要有image_src||color_code
          if (
            (config[value].show_type == 'show_image' && config[value].image_src) ||
            (config[value].show_type == 'show_block' && config[value].color_code)
          ) {
            onOff = true
          }
          break
        case 'auto_image':
          if (config[value].default_image_src) {
            onOff = true
          }
          break
        case 'auto_block':
          onOff = this.test_color(value)
          break
      }
      return onOff
    },
  },
  beforeMount() {
    this.paletteListLowerCase = paletteList.map((item) => {
      return item.toLowerCase()
    })
  },
  mounted() {
    if (!this.$refs.labelStyleWrap) return
    let validLabelLabel = this.$(this.$refs.labelStyleWrap?.[0]?.$el)?.find('label')
    if (!validLabelLabel.length) return
    this.validLabelWidth = validLabelLabel[0].parentNode.offsetWidth
    this.validLabelNum = validLabelLabel.length
    this.$el.style.setProperty('--el-width', this.$el.offsetWidth + 'px')
    this.elWidth = this.$el.offsetWidth
    this.$(window).resize(
      this.debounce(() => {
        this.$(this.$el).css('--el-width', this.$el.offsetWidth + 'px')
        if (this.$el.offsetWidth > 0) {
          this.elWidth = this.$el.offsetWidth
        }
      }, 200)
    )
  },

  components: {
    vIselect,
    vIlabel,
    vCustomSwiper,
    vPaletteLabel,
    vSelectStyle,
    vNumberLabel,
  },
}
</script>

<style lang="scss" scoped>
.variant_attrs_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: -10px;
  margin-right: -10px;
  line-height: 1;
  .variant_select {
    position: relative;
    max-width: 100%;
    min-width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    & > label {
      color: #1e0909;
      font-family: 'Roboto', sans-serif;
      pointer-events: none;
      font-weight: bold;
      font-size: 15px;
      line-height: 1.2;
    }
    .labelStyleBox {
      .athena-special-select {
        &::v-deep {
          .default-select {
            & > select {
              height: 52px;
              padding-left: 20px !important;
              border-color: #979cac !important;
              font-size: 16px;
              color: #222a40 !important;
              font-weight: 600;
              margin-bottom: 0;
            }
          }
          .default-select-dropdown {
            &::after {
              color: #222a40;
              font-weight: 600;
              right: 19px;
            }
          }
        }
      }
      .popupSelect {
        &::v-deep {
          .default-select {
            & > select {
              height: 34px;
              line-height: 17px;
              padding: 0 12px;
            }
          }
        }
      }
    }
  }
  .special_attr_select {
    display: inline-block;
    flex: 1;
    max-width: unset;
    min-width: unset;
  }
}
// .product_qty_box {
//   label {
//     line-height: 42px;
//     font-size: 15px;
//     font-weight: bold;
//   }
//   .product_qty {
//     float: right;
//     button {
//       background: rgba(255, 255, 255, 0.8);
//       padding: 0;
//       height: 36px;
//       width: 36px;
//       line-height: 34px;
//       border: 1px solid rgba(17, 17, 17, 0.2);
//       float: left;
//     }
//     input {
//       font-size: 13px;
//       color: #555;
//       background: #f5f5f5;
//       height: 36px;
//       width: 36px;
//       line-height: 34px;
//       text-align: center;
//       border: 1px solid rgba(17, 17, 17, 0.2);
//       margin: 0 -1px;
//       cursor: pointer;
//       float: left;
//       &::-webkit-inner-spin-button {
//         -webkit-appearance: none !important;
//         margin: 0;
//         -moz-appearance: textfield;
//       }
//     }
//   }
// }
@media screen and (max-width: 768px) {
  .labelStyle {
    .labelItem2 {
      min-width: 20px !important;
      min-height: 20px !important;
      label {
        vertical-align: middle;
        padding: 8px !important;
      }
    }
    .round,
    .fillet,
    .right_angle {
      div {
        min-width: 26px !important;
        min-height: 26px !important;
      }
    }
  }
  .variant_attrs_box {
    .variant_select {
      .labelStyleBox {
        .athena-special-select {
          &::v-deep {
            .default-select {
              & > select {
                padding: 0 10px !important;
                height: 34px;
                font-size: 13px;
              }
            }
            .default-select-dropdown {
              &::after {
                right: 10px;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
    .number-box {
      padding: 0 10px;
      &::v-deep .product_qty_box {
        max-width: 80px;
        min-width: 80px;
        .product_qty {
          button {
            border-color: #979cac !important;
            width: 30% !important;
            line-height: 1;
          }
          input {
            width: 40% !important;
          }
        }
      }
    }
  }
}
</style>
